import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({
    theme: {
      color: { ui6 },
    },
  }) => ui6};
  border-radius: 4px;
  height: 368px;
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 368px;
  max-height: 368px;
  margin: 24px;
  > img {
    z-index: 1;
    max-width: 100%;
    object-fit: contain;
    border: 1px solid
      ${({
        theme: {
          color: { ui4 },
        },
      }) => ui4};
  }
`;

export const Warning = styled.div`
  position: absolute;
  top: 5%;
  right: 0;
  transform: translateX(calc(50% - 1px));
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({
    theme: {
      color: { ac11 },
    },
  }) => ac11};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  z-index: 2;
  i {
    width: 16px;
    height: 16px;
  }
`;
